import { render } from "./UzhnetButtonSecondary.vue?vue&type=template&id=53e943bc&scoped=true"
import script from "./UzhnetButtonSecondary.vue?vue&type=script&lang=js"
export * from "./UzhnetButtonSecondary.vue?vue&type=script&lang=js"

import "./UzhnetButtonSecondary.vue?vue&type=style&index=0&id=53e943bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e943bc"]])

export default __exports__